// extracted by mini-css-extract-plugin
export default {"icon":"NavBar_icon__C8VjD","navbar":"NavBar_navbar__hUMMI","links":"NavBar_links__RMTPq","linkActive":"NavBar_linkActive__v7pzB"};